
const HighlightText = ({children}) =>{
    return(
        <span className="font-bold text-richblack-650">
            {" "}
            {children}
            {" "}
        </span>
    )
}

export default HighlightText;